import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  workExperience: [
    {
      id: '1',
      role: "Junior Security Analyst (Volunteer)",
      company: "TekHaven Solutions",
      period: "Feb 2025 – Present",
      type: "Volunteer",
      achievements: [
        "Co-developed an incident response playbook",
        "Assisted in SIEM setup and configuration",
        "Conducted penetration testing exercises",
        "Contributed to SOC maturity via lab simulations"
      ]
    },
    {
      id: '2',
      role: "Trainer & Cybersecurity Tutor",
      company: "CyberAdnation",
      period: "Feb 2024 – Present",
      type: "Education",
      achievements: [
        "Delivered hands-on cybersecurity training",
        "Designed labs for SOC practices and attack simulations",
        "Mentored students in practical security skills",
        "Developed curriculum for cybersecurity professionals"
      ]
    },
    {
      id: '3',
      role: "Assistant Site Engineer",
      company: "Abdulquadri Investment Limited",
      period: "Dec 2021 – Oct 2024",
      type: "Engineering",
      achievements: [
        "Supported technical site operations and documentation",
        "Developed foundational skills in teamwork and risk awareness",
        "Managed project coordination and technical reporting",
        "Applied systematic problem-solving approaches"
      ]
    }
  ],
  internshipsAndLearning: [
    {
      id: '1',
      title: "IoMT Intern & Assistant Team Lead",
      organization: "Klemweb (AI-IoMT Internship Program)",
      period: "May 2025 – Present",
      type: "Current",
      description: "Collaborating on algorithm design and Python-based solutions for IoMT security, supporting the team as Assistant Lead, and contributing to research on threats to medical devices."
    },
    {
      id: '2',
      title: "Cybersecurity Virtual Internships",
      organization: "CFCSR | Cyber Secure India | LetsWeHack",
      period: "2023–2024",
      type: "Virtual",
      description: "Analyzed Linux logs and network activity, explored ICS/SCADA security vulnerabilities, applied Suricata IDS, and practiced digital forensics, cloud security, and basic red teaming."
    },
    {
      id: '3',
      title: "Cyber & Forensic Security Solutions (Bootcamp)",
      organization: "Security Training Program",
      period: "Nov 2023 – Dec 2023",
      type: "Bootcamp",
      description: "Conducted ethical hacking labs and learned defensive countermeasures, strengthening understanding of attacker tactics and blue-team strategies."
    }
  ],
  achievements: [
    {
      id: '1',
      title: "Microsoft SC-200 Certification",
      description: "Achieved Microsoft SC-200 certification on the first attempt",
      icon: "Award"
    },
    {
      id: '2',
      title: "Advanced Malware Analysis Program",
      description: "Selected for the Advanced Malware Analysis & Cybercrime Investigations program",
      icon: "Bug"
    },
    {
      id: '3',
      title: "Cybersecurity Scholarship",
      description: "Received scholarship for Cyber Security at the International University of Applied Sciences, Germany",
      icon: "GraduationCap"
    },
    {
      id: '4',
      title: "RLabs Ambassador",
      description: "Appointed as RLabs Ambassador for community technology initiatives",
      icon: "Users"
    }
  ]
};

const experienceSlice = createSlice({
  name: 'experience',
  initialState,
  reducers: {
    addWorkExperience: (state, action) => {
      const newExp = {
        ...action.payload,
        id: Date.now().toString()
      };
      state.workExperience.push(newExp);
    },
    updateWorkExperience: (state, action) => {
      const { id, ...updates } = action.payload;
      const expIndex = state.workExperience.findIndex(exp => exp.id === id);
      if (expIndex !== -1) {
        state.workExperience[expIndex] = { ...state.workExperience[expIndex], ...updates };
      }
    },
    deleteWorkExperience: (state, action) => {
      state.workExperience = state.workExperience.filter(exp => exp.id !== action.payload);
    },
    addInternship: (state, action) => {
      const newInternship = {
        ...action.payload,
        id: Date.now().toString()
      };
      state.internshipsAndLearning.push(newInternship);
    },
    updateInternship: (state, action) => {
      const { id, ...updates } = action.payload;
      const internshipIndex = state.internshipsAndLearning.findIndex(internship => internship.id === id);
      if (internshipIndex !== -1) {
        state.internshipsAndLearning[internshipIndex] = { ...state.internshipsAndLearning[internshipIndex], ...updates };
      }
    },
    deleteInternship: (state, action) => {
      state.internshipsAndLearning = state.internshipsAndLearning.filter(internship => internship.id !== action.payload);
    },
    addAchievement: (state, action) => {
      const newAchievement = {
        ...action.payload,
        id: Date.now().toString()
      };
      state.achievements.push(newAchievement);
    },
    updateAchievement: (state, action) => {
      const { id, ...updates } = action.payload;
      const achievementIndex = state.achievements.findIndex(achievement => achievement.id === id);
      if (achievementIndex !== -1) {
        state.achievements[achievementIndex] = { ...state.achievements[achievementIndex], ...updates };
      }
    },
    deleteAchievement: (state, action) => {
      state.achievements = state.achievements.filter(achievement => achievement.id !== action.payload);
    }
  }
});

export const { 
  addWorkExperience, 
  updateWorkExperience, 
  deleteWorkExperience,
  addInternship,
  updateInternship,
  deleteInternship,
  addAchievement,
  updateAchievement,
  deleteAchievement 
} = experienceSlice.actions;
export default experienceSlice.reducer; 